import {
	faArrowRightFromBracket,
	faArrowsRepeat,
	faBook,
	faBuildingMemo,
	faChartLineUp,
	faChartMixed,
	faCircleCheck,
	faCircleDot,
	faCircleExclamation,
	faCircleInfo,
	faCirclePlus,
	faCircleXmark,
	faClone,
	faCog,
	faEnvelope,
	faFolders,
	faGlobe,
	faKey,
	faListTimeline,
	faPaintBrush,
	faShieldHalved,
	faSitemap,
	faTable,
	faTimer,
	faUpRightFromSquare,
	faUser,
	faUserCrown,
	faUsers,
	faUsersGear
} from '@fortawesome/pro-light-svg-icons';

import { IconLibrary } from '@silae/composables/icons';

export const ICON_LIBRARY: IconLibrary = {
	faArrowRightFromBracket,
	faUpRightFromSquare,
	faArrowsRepeat,
	faBook,
	faBuildingMemo,
	faChartLineUp,
	faChartMixed,
	faCircleCheck,
	faCircleDot,
	faCircleExclamation,
	faCircleInfo,
	faCirclePlus,
	faCircleXmark,
	faClone,
	faCog,
	faEnvelope,
	faFolders,
	faGlobe,
	faKey,
	faListTimeline,
	faPaintBrush,
	faShieldHalved,
	faSitemap,
	faTable,
	faTimer,
	faUser,
	faUserCrown,
	faUsers,
	faUsersGear
};
